module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/plan01_point-1878e48d76bd4f9b76ecc0b5eae706e3.jpg";